// Consent-aware analytics. GA4 / GTM only load when an ID is configured AND
// the visitor has accepted analytics cookies. Anonymous first-party event
// counts (no personal data, no cookies) are always recorded for the CRM.
import { API_BASE, GA4_ID, GTM_ID, ONLINE_FORMS_ENABLED } from "@/config/site";

const CONSENT_KEY = "uhlumo_cookie_consent_v1";
let loaded = false;

export const getConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
};

export const setConsent = (value) => {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    /* ignore */
  }
  if (value === "granted") initAnalytics();
  window.dispatchEvent(new CustomEvent("uhlumo:consent", { detail: value }));
};

export function initAnalytics() {
  if (loaded || getConsent() !== "granted") return;
  window.dataLayer = window.dataLayer || [];
  if (GA4_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(s);
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA4_ID, { anonymize_ip: true, send_page_view: false });
  }
  if (GTM_ID) {
    window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
    const g = document.createElement("script");
    g.async = true;
    g.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(g);
  }
  loaded = true;
}

export function trackPageView(path) {
  if (getConsent() !== "granted") return;
  if (window.gtag && GA4_ID) window.gtag("event", "page_view", { page_path: path, page_location: window.location.href });
  if (window.dataLayer && GTM_ID) window.dataLayer.push({ event: "page_view", page_path: path });
}

export function trackEvent(name, params = {}) {
  // Anonymous first-party count
  try {
    if (ONLINE_FORMS_ENABLED) {
    const body = JSON.stringify({ name, path: window.location.pathname, product: params.product || null });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API_BASE}/events`, new Blob([body], { type: "application/json" }));
    } else {
      fetch(`${API_BASE}/events`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true });
    }
    }
  } catch {
    /* ignore */
  }
  if (getConsent() !== "granted") return;
  if (window.gtag && GA4_ID) window.gtag("event", name, params);
  if (window.dataLayer && GTM_ID) window.dataLayer.push({ event: name, ...params });
}
